import { FormBuilder } from "@angular/forms";

export function cabinGroup (fb: FormBuilder): void {
    fb.group({
        cabin: [''],
    });
}
